module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-6-16a5599f936d3e1cbeb16ccc397ed0af.jpg";